import React, { memo } from 'react'
import PropTypes from 'prop-types'

import { util } from '../../../util'
import { Icon, Typography } from '..'
import { Link } from 'react-router-dom'

const PageNotification = ({
    iconProps,
    iconLabel,
    description,
    type,
    show,
    redirectContent,
    redirectLink,
}) => {
    if (!show) {
        return null
    }
    return (
        <div className={util.joinClasses('page-notification', type && `type-${type}`)}>
            <div className={'page-notification__icon'}>
                <Icon {...iconProps} />
                <Typography text={iconLabel} className={'px-2'} size={'rg'} fontType={'bold'} />
            </div>
            <div className={'page-notification__description'}>
                <Typography text={description} size={'sm'} />
                {redirectLink && redirectContent ? (
                    <Link to={redirectLink}>
                        <Typography
                            className={'redirect-link'}
                            text={redirectContent}
                            size={'sm'}
                            isUnderline
                        />
                    </Link>
                ) : null}
            </div>
        </div>
    )
}

PageNotification.propTypes = {
    show: PropTypes.bool,
    iconProps: PropTypes.shape({
        color: PropTypes.oneOf(['gray']),
        size: PropTypes.oneOf(['md']),
        renderIcon: PropTypes.node,
    }),
    iconLabel: PropTypes.string,
    description: PropTypes.string,
    type: PropTypes.oneOf(['warning']),
    redirectLink: PropTypes.string,
    redirectContent: PropTypes.string,
}

export default memo(PageNotification)
